// extracted by mini-css-extract-plugin
module.exports = {"container":"SetPassword_container__1jVQH","card":"SetPassword_card__1-nUd","content":"SetPassword_content__4nOi2","inputs":"SetPassword_inputs__2omHn"};